import { growthItems, type GrowthItem } from "../WhyUsSection.data";

interface GrowthListProps {
  items?: GrowthItem[];
}

export function GrowthList({ items = growthItems }: GrowthListProps) {
  return (
    <ul className="mt-2">
      {items.map(({ title, description, Icon, bgClass, textClass }, i) => (
        <li key={title}>
          {i > 0 && (
            <div className="h-px w-full bg-gradient-to-r from-transparent via-foreground/15 to-transparent" />
          )}
          <div className="flex items-center gap-4 py-5">
            <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${bgClass}`}>
              <Icon className={`h-6 w-6 ${textClass}`} strokeWidth={2.25} />
            </span>
            <div className="text-left">
              <p className="text-lg text-foreground font-semibold">{title}</p>
              <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
